/**
 * Immutable View: `readonly` properties, frozen at the end of the constructor.
 * The bytes of a template version's `.docx`; a template version is immutable, so the version id is
 * enough to know whether the held file is the right one.
 */
class DocumentTemplateFileView {
	readonly templateVersionId: number;
	readonly bytes: Uint8Array;

	constructor(templateVersionId: number, bytes: Uint8Array) {
		this.templateVersionId = templateVersionId;
		this.bytes = bytes;

		Object.freeze(this);
	}
}

export default DocumentTemplateFileView;
